import { render, staticRenderFns } from "./LeagueTableWidget.vue?vue&type=template&id=eb8239e6&scoped=true"
import script from "./LeagueTableWidget.vue?vue&type=script&lang=js"
export * from "./LeagueTableWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8239e6",
  null
  
)

export default component.exports